if (!customElements.get('iwto-description-expand')) {
  class IwtoDescriptionExpand extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      const content = this.querySelector('.iwto-desc-expand__content');
      const toggle = this.querySelector('.iwto-desc-expand__toggle');
      if (!content || !toggle) return;

      const checkOverflow = () => {
        if (this.classList.contains('is-expanded')) return;

        content.classList.remove('is-clamped');
        const fullHeight = content.scrollHeight;
        content.classList.add('is-clamped');
        const clampedHeight = content.clientHeight;

        const hasOverflow = fullHeight > clampedHeight + 2;
        this.classList.toggle('has-overflow', hasOverflow);
        toggle.classList.toggle('hidden', !hasOverflow);
      };

      const scheduleOverflowCheck = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(checkOverflow);
        });
      };

      scheduleOverflowCheck();
      window.addEventListener('resize', checkOverflow);
      window.addEventListener('load', checkOverflow);
      if (document.fonts?.ready) {
        document.fonts.ready.then(checkOverflow);
      }

      toggle.addEventListener('click', () => {
        const expanded = this.classList.toggle('is-expanded');
        content.classList.toggle('is-clamped', !expanded);
        toggle.setAttribute('aria-expanded', expanded);
        toggle.querySelector('.label-more')?.classList.toggle('hidden', expanded);
        toggle.querySelector('.label-less')?.classList.toggle('hidden', !expanded);
        this.classList.toggle('has-overflow', !expanded);
        if (!expanded) scheduleOverflowCheck();
      });
    }
  }

  customElements.define('iwto-description-expand', IwtoDescriptionExpand);
}
